import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { isWindowDefined } from '@core/Constants/Window';
import { deepGet } from '@core/Utils/DeepGet';
import { deepSet } from '@core/Utils/DeepSet';

import { checkoutDataByIdAtom } from './CheckoutData.atom';

export const checkoutDataFieldValueAtom = atomFamily((fieldId: string) =>
  atom(
    get => {
      const checkoutData = get(checkoutDataByIdAtom);

      // @ts-expect-error - window object does not have this type
      if (isWindowDefined) window.checkoutData = checkoutData;

      return deepGet(checkoutData, fieldId);
    },
    (get, set, value) => {
      const newCheckoutData = deepSet(get(checkoutDataByIdAtom), fieldId, value);
      set(checkoutDataByIdAtom, newCheckoutData);
    },
  ),
);
